import React, { useState, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import ContentBlock from "../components/ContentBlock/ContentBlock"
import PageTitle from "../components/PageTitle/PageTitle"
import { Container } from "react-bootstrap"

const styles = {
  li: {
    marginBottom: "1rem",
  },
}

const PhotoContest = ({ data }) => {
  
  const photos = useStaticQuery(graphql`
    query {
      lostRiverRanch: file(relativePath: { eq: "Lost-River-Ranch.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `)

  


  return (
    <Layout>
      <SEO title="Past USS IDAHO Photo Contest" />
      <Container fluid className="container-fluid-full">
        <PageTitle pageTitle="USS IDAHO Photo Contest">
          {/* {page.pageTitle} */}
        </PageTitle>
        <ContentBlock>
        <div
            style={{ padding: "0", position: "relative", marginBottom: "2rem" }}
          >
            <div
              style={{
                marginBottom: "2rem",
              }}
            >
              <h1
                style={{
                  color: "#3E597F",
                  fontSize: "clamp(1.5rem, 4.5vw, 2.5rem)",
                  fontWeight: "bold",
                  
                  marginBottom: "1rem",
                }}
              >
                The USS IDAHO Photo Contest: Idaho, Undersea and Underway
              </h1>

              <div
                className="text-center"
                style={{
                  color: "#3E597F",
                  fontSize: "clamp(1.1rem, 3vw, 1.5rem)",
                  fontWeight: "bold",
                  
                }}
              >
                <h3 style={{ fontSize: "inherit", marginBottom: "1rem", marginLeft: "5rem", marginRight: "5rem" }}>
                  <strong>Announcing the First Group of Winning Photographers for the USS IDAHO Photo Contest</strong>
                </h3>
              
              
              </div>
            </div>
            <div className="d-flex flex-row flex-wrap mb-4">
            <div className="col-md-6 mb-4">
            
            <p>
            The first round of photographs have been selected to be physically installed in either a vinyl wrap or mounted on an acrylic panel aboard the future USS IDAHO SSN 799 to represent Idaho's incredible beauty! Additional images may be selected in the weeks and months to come for physical or digital display.</p>
            <p>The USS IDAHO Photo Contest: Idaho, Undersea and Underway, received 2,325 images from 413 photographers. The competition was tough. We appreciate and thank the photographers listed below whose generous contributions will enhance the lives of USS IDAHO SSN 799 crew members on a daily basis.</p>
           
            <p>
              <strong>Winning Photographers Are:</strong>
            </p>
            <ul style={{listStyleType: "none", paddingLeft: 0}}>
              <li>Brooke Baldwin</li>

<li>Steve Dondero</li>
<li>Neal Drury</li>
<li>Kari Hudson</li>
<li>Jim Jenkins</li>
<li>Jordan Jensen</li>
<li>William Junk</li>
<li>Robert Karns</li>
<li>Charles Knowles</li>
<li>Mark Mitchell</li>
<li>Corey Mitchell</li>
<li>Tony Moody</li>
<li>Catherine Owens</li>
<li>Stanley Petersen</li>
<li>Peter Ramirez</li>
<li>Marty Sattison</li>
<li>Logan Smith</li>
<li>Corey Surber</li>
            </ul>
           <p><strong>Congratulations!</strong></p> 
            
           
          </div>
              <div className="col-md-6 mb-4">
                <GatsbyImage
                      image={photos.lostRiverRanch.childImageSharp.gatsbyImageData}
                      alt={"Leeann Cline"}
                      style={{
                        width: "100%",
                        borderRadius: ".375rem",
                        overflow: "hidden",
                        height: "100%",
                        objectFit: "contain",
    
                      }}
                      imgStyle={{
                        borderRadius: ".375rem",
                        aspectRatio: "3/2",
                      }}
                    />
                    <div style={{ position: "absolute", right: 2, bottom: 0, color: "white", fontSize: "0.8rem", fontWeight: "bold", textShadow: "0 0 10px rgba(0, 0, 0, 0.5)", padding: "1rem" }}>
                      Photo by {"Tony Moody"}
                    </div>
              </div>
              
            </div>
            
          </div>
 
        </ContentBlock>
      </Container>
    </Layout>
  )
}

export default PhotoContest
